module.exports = __webpack_public_path__ + "d2694da86ecb69d6799dc927889b157d.svg";